import { render, staticRenderFns } from "./AttachmentGallery.vue?vue&type=template&id=0c72003a&scoped=true"
import script from "./AttachmentGallery.vue?vue&type=script&lang=js"
export * from "./AttachmentGallery.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGallery.vue?vue&type=style&index=0&id=0c72003a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72003a",
  null
  
)

export default component.exports